// preview 專用：活動花絮 mosaic 拼貼（大小不等磚，雜誌感），取代齊一網格。
import { useEffect, useState } from "react";
import { ACTIVITY_PHOTOS } from "./home_page_v2_demo_data";

const DemoActivityMosaic = ({ photos = ACTIVITY_PHOTOS }) => {
  const [cols, setCols] = useState(4);
  useEffect(() => {
    const update = () => setCols(window.innerWidth < 768 ? 2 : 4);
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: `repeat(${cols}, 1fr)`,
        gridAutoRows: "130px",
        gap: "10px",
      }}
    >
      {photos.map((p, i) => {
        // 第 0 張大磚 (2x2)，第 3 張寬磚 (2 寬)，其餘 1x1 → 拼貼節奏
        const span =
          cols === 4 && i === 0
            ? { gridColumn: "span 2", gridRow: "span 2" }
            : cols === 4 && i === 3
            ? { gridColumn: "span 2" }
            : {};
        return (
          <div
            key={i}
            style={{
              position: "relative",
              borderRadius: "12px",
              overflow: "hidden",
              boxShadow: "0 3px 10px rgba(0,0,0,0.25)",
              ...span,
            }}
          >
            <img
              src={p.src}
              alt={p.title}
              loading="lazy"
              style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
            />
            <div
              style={{
                position: "absolute",
                left: 0,
                right: 0,
                bottom: 0,
                padding: "20px 12px 10px",
                background: "linear-gradient(transparent, rgba(0,0,0,0.72))",
                color: "#fff",
                fontWeight: 600,
                fontSize: i === 0 && cols === 4 ? "1.1rem" : "0.9rem",
              }}
            >
              {p.title}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default DemoActivityMosaic;
